<template>
  <div class="second-menu-link-content">
    <h2 class="link-title">
      <!-- 标题 -->
      <slot name="header"></slot>
    </h2>
    <div id="link-content" ref="linkContent" class="link-content">
      <div class="link-content-inner-container">
        <div ref="content" class="content">
          <!-- 内容区 -->
          <slot name="content"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script >
export default {
  data() {
    return {};
  },
  mounted() {
    const paddingHeight = 50;
    let _this = this;
    this.$refs.content.style.minHeight = `${parseInt(
      this.$refs.linkContent.getBoundingClientRect().height,
      10
    ) - paddingHeight}px`;
    this.$refs.content.style.width = `${parseInt(
      this.$refs.linkContent.getBoundingClientRect().width
    ) - 100}px`;
    window.onresize = () => {
      this.sendResize();
      _this.$refs.content.style.minHeight = `${parseInt(
        _this.$refs.linkContent.getBoundingClientRect().height,
        10
      ) - paddingHeight}px`;
      _this.$refs.content.style.width = `${parseInt(
        _this.$refs.linkContent.getBoundingClientRect().width
      ) - 100}px`;
    };
  },
  components: {},
  methods: {
    sendResize() {
      this.$emit("onresize", true);
    }
  }
};
</script>

<style lang="scss" scoped>
.second-menu-link-content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  letter-spacing: 1px;
  .link-title {
    margin: 0;
    width: 100%;
    height: 40px;
    flex-shrink: 0;
    box-sizing: border-box;
    padding-left: 20px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    font-size: 16px;
    font-family: "PingFangSC-Regular";
    font-weight: 400;
    background: #ebedf1;
    border-left: 1px solid #f5f7fa;
  }
  .link-content {
    flex-grow: 1;
    box-sizing: border-box;
    width: 100%;
    background: #f5f7fa;
    padding: 16px 16px 16px 16px;
    overflow: auto;
    .link-content-inner-container {
      box-sizing: border-box;
      width: 100%;
      background: #ffffff;
      padding: 16px 24px;
      box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.06);
      border-radius: 4px;
      .content {
        width: 100%;
        height: 100%;
        position: relative;
        box-sizing: border-box;
      }
    }
  }
}
</style>
